import React, { ChangeEventHandler, ReactNode } from "react";
import './styles.less'
import { generateUniqueId } from "src/utils/Functions";
type Props = {
	className?: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	name?: string;
	id?: string;
	value?: string;
	checked?: boolean;
	children?: ReactNode;
	defaultChecked?: boolean;
	hasError?: boolean
};

const CheckboxCustomInput = (props: Props) => {
	const uniqueId = `${props.id ?? props.name}-${generateUniqueId()}`

	return (
		<div className={props.className} style={{width: '100%'}}>
			<div className={`checkboxCustomContainer`}>
				<input
					type="checkbox"
					className="checkBoxCustomInput"
					onChange={props.onChange}
					name={props.name}
					id={uniqueId}
					value={props.value}
					defaultChecked={props.defaultChecked}
					checked={props.checked}
					required
				/>
				<label htmlFor={uniqueId}>{props.children}</label>
			</div>
			{props.hasError && <span className="error-message">Obligatorio aceptar términos y condiciones</span>}
		</div>
	);
};

export default CheckboxCustomInput;

